import { FC } from 'react';
import type { ImageField } from '@prismicio/client';
import { PrismicNextImage } from '@prismicio/next';
import { cn } from '@/lib/utils';

type Props = { logo: ImageField; className?: string };

export const CalloutLogo: FC<Props> = ({ logo, className }) => (
  <PrismicNextImage
    field={logo}
    className={cn('h-auto w-auto max-w-full', className)}
    fallbackAlt=""
  />
);
